import SimpleHeader from '@/containers/header';
import Footer from '@/containers/footer';
import { grid } from '@/constants/grid';
import Header from '@/bit/components/components.header';
import { useSelector } from 'react-redux';

const Page = ({
  pageId,
  children,
  showMainHeader = false,
  columnForm = false,
}) => {
  const headerProps = useSelector((state) => state.header);
  return (
    <div id={pageId} className="page" data-cy={pageId}>
      {!showMainHeader && (
        <div className="header">
          <div className="container">
            <div className="row">
              <div
                className={`page__header ${
                  columnForm ? 'col-form-header--center' : 'col-form-header'
                } col-sm-12 col-xs-12`}
              >
                <SimpleHeader cyData={`${pageId}__header`} />
              </div>
            </div>
          </div>
        </div>
      )}
      {showMainHeader && <Header {...headerProps} />}
      {children}
      <div className="footer">
        <Footer cyData={`${pageId}__footer`} />
      </div>
      <style jsx>
        {`
          .page {
            display: flex;
            flex-direction: column;
            min-height: ${showMainHeader
              ? 'calc(calc(var(--vh, 1vh) * 100) - 60px)'
              : ' calc(var(--vh, 1vh) * 100)'};
            .page__header {
              margin-top: 22px;
            }
            :global(.footer) {
              margin-top: auto;
            }
          }
          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .col-form-header--center {
              display: flex;
              justify-content: center;
            }
          }
          @media screen and (min-width: ${grid.breakpoint_lg}px) {
            .page {
              min-height: ${showMainHeader
                ? 'calc(calc(var(--vh, 1vh) * 100) - 80px)'
                : ' calc(var(--vh, 1vh) * 100)'};
            }
            .col-form-header {
              display: grid;
              grid-column-start: 2;
              grid-column-end: 12;
            }
          }
        `}
      </style>
    </div>
  );
};
export default Page;
